// VENDOR FILES
// -----------------------------------------------------------------------------
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';

// CUSTOM CODE
// -----------------------------------------------------------------------------

function focusNextElement(container) {
    const focusableSelectors =
        'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    const allFocusable = Array.prototype.filter.call(document.querySelectorAll(focusableSelectors), function (element) {
        return element.offsetWidth > 0 || element.offsetHeight > 0;
    });

    const lastFocusableInContainer = Array.from(container.querySelectorAll(focusableSelectors)).pop();
    const index = allFocusable.indexOf(lastFocusableInContainer);

    if (index > -1 && index < allFocusable.length - 1) {
        allFocusable[index + 1].focus();
    }
}

function randomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

function manageFormFields() {
    const validateRDKs = document.querySelectorAll('input[id^="rdky"]');
    if (validateRDKs.length === 0) {
        return;
    }

    validateRDKs.forEach((rdk) => {
        // Get last character of ID
        const lastChar = rdk.id.charAt(rdk.id.length - 1);
        switch (lastChar) {
            case 'a':
            case 'b':
                rdk.value = randomString(16);
                break;
            case 'z':
                rdk.value = `${validateRDKs[0].value}${validateRDKs[1].value}`; // concatenate a and b RDKs
                break;
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('figure.wp-block-table table th').forEach(function (th) {
        if (!th.textContent.trim()) {
            th.setAttribute('aria-hidden', 'true');
        }
    });

    manageFormFields();

    // MOBILE NAV SCRIPTS
    // ------------------
    // - Accordion Behavior for Mobile Scripts
    const hamburger = document.getElementById('hamburger-button');
    if (hamburger) {
        hamburger.addEventListener('click', function () {
            document.querySelector('body').classList.toggle('mobile-menu-open');
        });
    }

    const categoryHeads = document.querySelectorAll('.category-head');

    categoryHeads.forEach(function (categoryHead) {
        categoryHead.addEventListener('click', function () {
            const submenuContainer = categoryHead.nextElementSibling;

            if (submenuContainer.style.maxHeight) {
                submenuContainer.style.maxHeight = null;
                categoryHead.classList.remove('open');
            } else {
                document.querySelectorAll('.category-head').forEach(function (head) {
                    const container = head.nextElementSibling;
                    if (container.style.maxHeight) {
                        container.style.maxHeight = null;
                        head.classList.remove('open');
                    }
                });

                submenuContainer.style.maxHeight = submenuContainer.scrollHeight + 'px';
                categoryHead.classList.add('open');
            }
        });
    });

    // Get references to the elements
    const searchTrigger = document.querySelector('.menu-primary-search-trigger');
    const searchMenu = document.querySelector('.menu-primary-search');
    const searchInput = document.querySelector('.search-form-input');

    // Add an event listener to the trigger element
    searchTrigger.addEventListener('click', function () {
        // Toggle the 'menu-primary-search-expanded' class on the .menu-primary-search element
        searchMenu.classList.toggle('menu-primary-search-expanded');

        //Accessibility
        // Update aria-expanded attribute
        const isExpanded = searchMenu.classList.contains('menu-primary-search-expanded');
        searchTrigger.setAttribute('aria-expanded', isExpanded);

        // If the .menu-primary-search has the 'menu-primary-search-expanded' class, focus on the input field
        if (isExpanded) {
            searchInput.focus();
        } else {
            // If the menu is collapsed, focus on the trigger element
            searchTrigger.focus();
        }
    });

    const scAcSearchInput = document.querySelector('.sc-acsearch-input');
    const scAcSearchHook = document.querySelector('.sc-acsearch-hook button');

    // Function to get query parameter value by name
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Get the value of '?s' from the URL
    const searchQuery = getQueryParam('s');
    if (searchQuery && scAcSearchInput) {
        scAcSearchInput.value = searchQuery;
        scAcSearchHook.click();
    }

    if (scAcSearchInput) {
        scAcSearchInput.addEventListener('input', function () {
            scAcSearchHook.click();
        });
    }

    // Append '&q=searchQuery' to the URL if searchQuery exists
    if (searchQuery) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('q', searchQuery);
        window.history.replaceState({}, '', currentUrl);
    }

    const dotsElements = document.querySelectorAll('.page-numbers.dots');
    dotsElements.forEach((dot) => {
        dot.textContent = 'of';
    });

    if (document.querySelector('.banner-close')) {
        document.querySelector('.banner-close a').addEventListener('click', function (e) {
            e.preventDefault();
            const banner = document.querySelector('.banner');
            banner.classList.add('banner-closed');
            // Wait for transition to finish
            setTimeout(() => {
                banner.remove();
            }, '300');
        });
    }

    if (document.querySelector('.carousel-dynamic')) {
        document.querySelectorAll('.carousel-dynamic .wp-block-post-template').forEach((element) => element.classList.add('splide__list'));
        document.querySelectorAll('.carousel-dynamic .wp-block-post').forEach((element) => element.classList.add('splide__slide'));

        document.querySelectorAll('.carousel-dynamic').forEach((element, index) => {
            element.classList.add(`carousel-dynamic-${index}`);

            const slideQuote = element.querySelector('.carousel-quote');

            const carouselDynamic = new Splide(`.carousel-dynamic-${index}`, {
                type: 'loop',
                arrows: true,
                autoplay: false,
                pagination: true,
                autoWidth: false,
                perPage: 4,
                mediaQuery: 'min',
                breakpoints: {
                    0: {
                        perPage: 1,
                    },
                    600: {
                        perPage: 2,
                    },
                    1000: {
                        perPage: 4,
                        drag: false,
                        arrows: false,
                        pagination: false,
                        type: 'slide',
                    },
                },
            }).mount();

            if (slideQuote) {
                carouselDynamic.add('<li class="splide__slide">' + slideQuote.outerHTML + '</li>', 0);
                slideQuote.remove();
            }
        });
    }

    if (document.querySelector('.carousel-featured')) {
        document.querySelectorAll('.carousel-featured').forEach((element, index) => {
            // Add a unique class for each carousel instance
            element.classList.add(`carousel-featured-${index}`);

            // Initialize Splide for each carousel instance.
            // focusableNodes is set to an empty string to prevent Splide from
            // managing tabindex on links inside slides — the custom keydown
            // handler below takes over tabindex management so that all slide
            // buttons remain keyboard-accessible in Safari (which does not
            // natively Tab-focus <a> elements).
            const carouselFeatured = new Splide(`.carousel-featured-${index}`, {
                type: 'loop',
                autoplay: false,
                pagination: true,
                autoWidth: false,
                perPage: 4,
                mediaQuery: 'min',
                breakpoints: {
                    0: {
                        perPage: 1,
                        arrows: true,
                    },
                    600: {
                        perPage: 1,
                    },
                    1000: {
                        perPage: 1,
                        type: 'slide',
                        arrows: false,
                    },
                },
            });

            // Select carousel tabs related to the current carousel instance
            const carouselTabs = element.querySelectorAll('.carousel-featured-title');

            carouselFeatured.on('pagination:mounted', function (data) {
                // Pagination container.
                const pagination = element.querySelector('.splide__pagination');

                // The list of pagination buttons.
                const paginationButtons = element.querySelectorAll('.splide__pagination__page');

                // Splide tracklist.
                const track = element.querySelector('.splide__track');

                // Move the pagination element above the track
                element.insertBefore(pagination, track);

                carouselTabs.forEach((carouselTab, index) => {
                    if (data.items[index] && data.items[index].button) {
                        // Set the button's innerHTML to render any HTML entities correctly
                        data.items[index].button.innerHTML = carouselTab.innerHTML;
                        const button = data.items[index].button;
                        button.innerHTML = carouselTab.innerHTML;

                        const tabText = carouselTab.textContent ? carouselTab.textContent.replace(/\s+/g, ' ').trim() : '';
                        const baseAriaLabel = button.getAttribute('aria-label') || '';
                        const normalizedBaseLabel = baseAriaLabel.replace(/^Go to\s+/i, '').trim();

                        if (normalizedBaseLabel && tabText && !normalizedBaseLabel.endsWith(` - ${tabText}`)) {
                            button.setAttribute('aria-label', `${normalizedBaseLabel} - ${tabText}`);
                        }
                    }
                });

                paginationButtons.forEach((button) => {
                    button.addEventListener('click', function () {
                        this.focus({ focusVisible: true });
                    });
                });

                carouselTabs.forEach((e) => e.remove());
            });

            let currentBlockButtons = []; // Store all focusable buttons in the active slide.

            // Handle Tab from pagination to slide button.
            // Tab functionality should go from pagination button -> slide button -> next pagination button.
            element.addEventListener('keydown', function (event) {
                if (event.key === 'Tab') {
                    const currentActivePagination = element.querySelector('.splide__pagination__page.is-active');
                    const allPaginationButtons = element.querySelectorAll('.splide__pagination__page');
                    const currentPaginationIndex = Array.from(allPaginationButtons).indexOf(currentActivePagination);
                    const currentButtonIndex = currentBlockButtons.indexOf(event.target);

                    if (!event.shiftKey) {
                        // Forward tabbing
                        if (event.target === currentActivePagination && currentBlockButtons.length > 0) {
                            // Tab from active pagination to the first slide button
                            event.preventDefault();
                            currentBlockButtons[0].focus();
                        } else if (currentButtonIndex !== -1) {
                            // Currently focused on a slide button — move to the next one or jump to the next tab
                            const nextButtonIndex = currentButtonIndex + 1;

                            if (nextButtonIndex < currentBlockButtons.length) {
                                // Move to the next button within the same slide
                                event.preventDefault();
                                currentBlockButtons[nextButtonIndex].focus();
                            } else {
                                // All slide buttons visited — move to the next pagination tab
                                const nextPaginationIndex = currentPaginationIndex + 1;

                                if (nextPaginationIndex < allPaginationButtons.length) {
                                    const nextPaginationButton =
                                        allPaginationButtons[nextPaginationIndex];
                                    event.preventDefault();
                                    nextPaginationButton.focus();
                                    nextPaginationButton.click();
                                } else {
                                    // Past the last tab — let focus leave the carousel naturally
                                    event.preventDefault();
                                    currentBlockButtons.forEach((btn) =>
                                        btn.setAttribute('tabindex', '-1')
                                    );
                                    focusNextElement(element);
                                    currentBlockButtons.forEach((btn) =>
                                        btn.setAttribute('tabindex', '0')
                                    );
                                }
                            }
                        }
                    } else {
                        // Reverse tabbing (Shift+Tab)
                        if (currentButtonIndex !== -1) {
                            if (currentButtonIndex > 0) {
                                // Move to the previous button within the same slide
                                event.preventDefault();
                                currentBlockButtons[currentButtonIndex - 1].focus();
                            } else {
                                // First slide button — go back to the active pagination button
                                event.preventDefault();
                                currentActivePagination.focus();
                            }
                        } else if (event.target === currentActivePagination) {
                            const prevPaginationIndex = currentPaginationIndex - 1;

                            if (prevPaginationIndex >= 0) {
                                const prevPaginationButton = allPaginationButtons[prevPaginationIndex];
                                event.preventDefault();
                                prevPaginationButton.click();
                                prevPaginationButton.focus();

                                setTimeout(() => {
                                    const newActiveSlide = element.querySelector('.splide__slide.is-active');
                                    const prevCTAButton = newActiveSlide ? newActiveSlide.querySelector('.wp-block-button__link') : null;
                                    if (prevCTAButton) {
                                        prevCTAButton.focus();
                                    }
                                }, 50);
                            }
                        }
                    }
                }
            });

            // Update state on slide change
            carouselFeatured.on('active', function (slide) {
                const activeSlide = slide.slide;
                currentBlockButtons = Array.from(activeSlide.querySelectorAll('.wp-block-button__link'));

                const blockButtonLinks = element.querySelectorAll('.wp-block-button__link');

                // Set all slide buttons to not be tabbable except the ones in the active slide
                blockButtonLinks.forEach((link) => {
                    link.setAttribute('tabindex', '-1');
                });

                // Make the current slide's button tabbable
                if (currentBlockButtons.length > 0) {
                    currentBlockButtons[0].setAttribute('tabindex', '0');
                }

                // Update pagination button states
                const allPaginationButtons = element.querySelectorAll('.splide__pagination__page');

                allPaginationButtons.forEach((button) => {
                    if (button.classList.contains('is-active')) {
                        button.setAttribute('aria-selected', 'true');
                        button.setAttribute('tabindex', '0');
                    } else {
                        button.setAttribute('aria-selected', 'false');
                        button.setAttribute('tabindex', '0');
                    }
                });
            });

            // Accessibility fix: Update tabindex and aria-selected on slide change
            carouselFeatured.on('move', function (newIndex) {
                document.querySelectorAll(`.carousel-featured-${index} .splide__slide`).forEach((slide, slideIndex) => {
                    if (slideIndex === newIndex) {
                        slide.removeAttribute('aria-hidden'); // Allow screen readers to see active tab
                    } else {
                        slide.setAttribute('aria-hidden', 'true'); // Hide from screen readers
                    }
                });
            });

            // Mount the carousel
            carouselFeatured.mount();
        });
    }

    document.querySelectorAll('.wp-block-pacecore-blocks-accordion_cta').forEach((accordion) => {
        // Add role="button" only if it doesn't already exist, this is so that we can
        // update the Pacecore blocks with the correct role and this script won't add a second one
        if (!accordion.hasAttribute('role')) {
            accordion.setAttribute('role', 'button');
        }

        // This ensures you can tab to the accordion
        if (!accordion.hasAttribute('tabindex')) {
            accordion.setAttribute('tabindex', '0');
        }

        // Add keyboard support: Enter and Space to trigger the accordion
        accordion.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Prevents a page scroll on Space
                this.click(); // Simulate a click to toggle the accordion
            }
        });
    });

    // Format pagination display as "current of total"
    function formatPaginationDisplay() {
        const paginationNumbersContainers = document.querySelectorAll('.wp-block-query-pagination-numbers');

        paginationNumbersContainers.forEach(container => {
            const allPageNumbers = container.querySelectorAll('a.page-numbers, span.page-numbers.current');

            if (allPageNumbers.length === 0) return;

            // Get the current page
            const currentPageElement = container.querySelector('span.page-numbers.current');
            const currentPage = currentPageElement ? parseInt(currentPageElement.textContent.trim()) : 1;

            // Get the last page number (the highest number)
            let totalPages = currentPage;
            allPageNumbers.forEach(el => {
                const pageNum = parseInt(el.textContent.trim());
                if (!isNaN(pageNum) && pageNum > totalPages) {
                    totalPages = pageNum;
                }
            });

            // Clear the container
            container.innerHTML = '';

            // Add the formatted text
            const displayText = document.createElement('span');
            displayText.className = 'pagination-display';
            displayText.textContent = `${currentPage} of ${totalPages}`;
            container.appendChild(displayText);
        });
    }

    formatPaginationDisplay();

    // Fix GDPR banner padding issue when banner is position: fixed
    function fixGdprBannerPadding() {
        const footer = document.getElementsByTagName('footer')[0];
        const banner = document.getElementById('gdpr-banner');

        if (footer && banner) {
            const bannerStyle = window.getComputedStyle(banner);
            if (bannerStyle.position === 'fixed' && bannerStyle.bottom === '0px') {
                footer.style.paddingBottom = footer.getAttribute('data-original-padding-bottom') || '';
            }
        }
    }

    // Handle GDPR banner focus management to prevent tab trapping
    function handleGdprBannerFocus() {
        const banner = document.getElementById('gdpr-banner');
        if (!banner) return;

        const btns = banner.querySelectorAll('.btn');
        btns.forEach((btn) => btn.setAttribute('tabindex', '0'));

        const skipLink = document.querySelector('.skip-link');
        const lastBtn = btns[btns.length - 1];

        // Helper to hide banner and focus skip link
        function hideBannerAndFocusSkipLink() {
            if (skipLink) skipLink.focus();
            banner.classList.add('gdpr-wrapper-hidden');
        }

        // Tab forward from lastBtn to skipLink
        if (lastBtn) {
            lastBtn.addEventListener('keydown', (event) => {
                if (event.key === 'Tab' && !event.shiftKey) {
                    event.preventDefault();
                    hideBannerAndFocusSkipLink();
                }
            });
        }

        // Tab backward from skipLink to lastBtn
        if (skipLink && lastBtn) {
            skipLink.addEventListener('keydown', (event) => {
                if (event.key === 'Tab' && event.shiftKey) {
                    event.preventDefault();
                    banner.classList.remove('gdpr-wrapper-hidden');
                    lastBtn.focus();
                }
            });
        }

        // Enter key for acknowledge and close buttons
        ['.js-gdpr-acknowledge', '.gdpr-close-button'].forEach((selector) => {
            const btn = banner.querySelector(selector);
            if (btn) {
                btn.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        hideBannerAndFocusSkipLink();
                        if (selector === '.js-gdpr-acknowledge') btn.click();
                    }
                });
            }
        });
    }

    // Single source of truth for third-party tracking/conversion pixel vendors.
    // These are injected without an alt attribute and as inline elements, so we
    // mark them decorative (image-alt) and tag them for the out-of-flow CSS.
    const trackingPixelSelector = [
        'img[src*="bidr.io"]',
        'img[src*="adsrvr.org"]',
        'img[src*="doubleclick.net"]',
        'img[src*="analytics.yahoo.com"]',
    ].join(',');

    function markTrackingPixelDecorative(pixel) {
        if (!pixel.hasAttribute('alt')) {
            pixel.setAttribute('alt', '');
        }
        pixel.setAttribute('aria-hidden', 'true');
        pixel.classList.add('is-tracking-pixel');
    }

    function sweepTrackingPixels(root) {
        if (root.matches && root.matches(trackingPixelSelector)) {
            markTrackingPixelDecorative(root);
        }
        if (root.querySelectorAll) {
            root.querySelectorAll(trackingPixelSelector).forEach(markTrackingPixelDecorative);
        }
    }

    sweepTrackingPixels(document);

    // Pixels are added asynchronously by tag managers, so watch for new ones.
    new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    sweepTrackingPixels(node);
                }
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () {
        setTimeout(fixGdprBannerPadding, 100);
        setTimeout(handleGdprBannerFocus, 100);
    });
});
